import styled from "styled-components";

const CustomLabel = styled.div`
  color: var(--elementDim);
  font-size: 14px;
  font-weight: 600;
  opacity: 0.8;
  text-transform: capitalize;
`;

export default CustomLabel;
